import '../styles/Prev.css';
import '../styles/Grille.css';
import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;

function Prev({ gameMode, isArchive, currentId }) {
    const { t } = useTranslation();
	const [guessPrev, setGuessPrev] = useState([]);
    const [historyIds, setHistoryIds] = useState([]);

    useEffect(() => {
        if (isArchive) return;
        let url;
        switch (gameMode) {
            case 'item':
                url = 'items-prev';
                break;
            case 'game':
                url = 'games-prev';
                break; 
            case 'character':
                url = 'characters-prev';
                break; 
            case 'sword':
                url = 'swords-prev';
                break; 
            default:
                url = 'items-prev';
        }
        fetch(`${URL_BACKEND}/api/${url}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(guessPrev => { 
                setGuessPrev(guessPrev); 
            })
            .catch(error => { console.error('Error fetching data:', error); });
    }, [gameMode, isArchive]);

    // Liste des ids d'archives pour naviguer précédent / suivant
    useEffect(() => {
        if (!isArchive) return;
        fetch(`${URL_BACKEND}/api/history/${gameMode}`)
            .then(r => {
                if (!r.ok) throw new Error('Not found');
                return r.json();
            })
            .then(data => {
                setHistoryIds(data.map(p => p.id_historique));
            })
            .catch(err => console.error('Error fetching history:', err));
    }, [gameMode, isArchive]);

    const { pathname } = useLocation();
    const basePath = pathname.split('/').slice(0, 2).join('/'); // /mode

    let prevId = null;
    let nextId = null;
    const current = Number(currentId);
    if (isArchive && historyIds.length) {
        const idx = historyIds.indexOf(current);
        if (idx > 0) prevId = historyIds[idx - 1];
        if (idx >= 0 && idx < historyIds.length - 1) nextId = historyIds[idx + 1];
        if (idx === -1 && historyIds.length > 0) nextId = historyIds[0];
    }

    const prevName = () => {
        if (gameMode === 'sword')
            return (<span className='span-white'>{guessPrev.nom_epee} ({guessPrev.acronyme_jeu})</span>);
        return null;
    };

	return (
		<div className="prev">
            {!isArchive && (
                <div className="prev-yesterday">
                    <span className='span-gold'>{t('prev.yesterdaysGuess')} : </span>
                    { 
                        gameMode === 'item' ?
                            (<span className='span-white'>{guessPrev.nom_item}</span>)
                        : gameMode === 'game' ?           
                            (<span className='span-white'>{guessPrev.nom_jeu}</span>)
                        : gameMode === 'character' ?           
                            (<span className='span-white'>{guessPrev.nom_personnage}</span>)
                        : gameMode === 'sword' ?           
                            prevName()
                        : null
                    }
                </div>
            )}

            {isArchive && historyIds.length > 0 && (
                <div className="prev-nav">
                    {prevId !== null ? (
                        <Link className="prev-nav-arrow left" to={`${basePath}/${prevId}`} title={t('prev.prev')}>&#160;</Link>
                    ) : (
                        <span className="prev-nav-arrow left disabled">&#160;</span>
                    )}
                    <span className="prev-nav-current">
                        <span className="prev-nav-current-label">{t('history.puzzle')}</span>
                        #{current}
                    </span>
                    {nextId !== null ? (
                        <Link className="prev-nav-arrow right" to={`${basePath}/${nextId}`} title={t('prev.next')}>&#160;</Link>
                    ) : (
                        <span className="prev-nav-arrow right disabled">&#160;</span>
                    )}
                </div>
            )}

            <div className="prev-history">
                <span className='span-gold'>{t('history.explore')} : </span>
                <Link className="prev-history-link" to={`/history/${gameMode}`}>{t('history.link')}</Link>
            </div>
		</div>
	)
}

export default Prev
